import { AxiosResponse } from "axios";
import { axiosPost, axiosDelete } from "../../../axios/axios-config";

import { CommonResponse } from "types/types";

interface CheckUserProps {
    email: string;
}

export const CheckUserRequest = async (
  data: CheckUserProps,
): Promise<void | AxiosResponse<CommonResponse>> => {
  return await axiosPost("/auth/check-user/", data);
};

export const UserInvitationRequest = async (
  data: CheckUserProps,
): Promise<void | AxiosResponse<CommonResponse>> => {
  return await axiosPost("/auth/send-invite/", data);
};

export const sendGiftBitRequest = async (data: {
  user: number;
  receiver_user_id: number;
  bit_id: number;
}): Promise<void | AxiosResponse<CommonResponse>> => {
  return await axiosPost("/auth/gift-bit/", data);
};

